import { render, staticRenderFns } from "./TokenDocs.vue?vue&type=template&id=6a20434e&"
import script from "./TokenDocs.vue?vue&type=script&lang=ts&"
export * from "./TokenDocs.vue?vue&type=script&lang=ts&"
import style0 from "./TokenDocs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports